import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AddComma} from "../../utils";
import ellipse from '../../style/images/Group-5.png';
import {connect} from 'trim-redux';

const ReceptionInfo = ({top , ipgCalled=false,receptionLogo , interest , little
                           , pos , amount , supplierName, website , terminal , branchCode ,branchName}) => {
   
    return (
        <div className={ipgCalled ? "payment payment-ipgCalled recep-payment": "payment recep-payment"}
             style={{boxSizing: "border-box" , padding: '18px 20px' , marginRight: 20 , minHeight: 258}}>
            <div className='payment-title'>
                        <span>
                            <img src={ellipse}/>
                        </span>
                <h3 style={{marginRight: 10}}>اطلاعات پذیرنده</h3>
            </div>
            <div className={little ? 'installment-info reception-info noHeight' : 'installment-info reception-info '} style={{marginTop: "20px"}}>
                <section>
                    <span className='info-titles' > :نام پذیرنده</span>
                </section>
                <section style={{marginRight: 13}}>
                    <span className='info-details' style={{fontSize: '14px'}}>{localStorage.supplierName}</span>
                    
                        {/*<img src={receptionLogo} className='reception-logo'/>*/}
                </section>
            </div>
            {
                branchName !== "" ?   <div className={little ? 'installment-info reception-info noHeight' : 'installment-info reception-info '} style={{marginBottom: 8}}>
                    <section>
                        <span className='info-titles' > :شعبه</span>
                    </section>
                    <section style={{display: 'flex' , flexDirection: 'row-reverse' , marginRight: 13}}>
                        <span className='info-details' style={{fontSize: '14px'}}>{branchName}</span>
                    </section>
                </div> : <span></span>
            }
            {
                branchCode !== " " ?   <div className={little ? 'installment-info reception-info noHeight' : 'installment-info reception-info '} style={{marginBottom: 8}}>
                    <section>
                        <span className='info-titles' > :کد شعبه</span>
                    </section>
                    <section style={{display: 'flex' , flexDirection: 'row-reverse' , marginRight: 13}}>
                        <span className='info-details' style={{fontSize: '14px'}}>{branchCode}</span>
                    </section>
                </div> : <span></span>
            }
            <div className={little ? 'installment-info reception-info noHeight' : 'installment-info reception-info '}>
                <section>
                    <span className='info-titles' > :شماره ترمینال پذیرنده</span>
                </section>
                <section style={{display: 'flex' , flexDirection: 'row-reverse' , marginRight: 13}}>
                    <span className='info-details' style={{fontSize: '14px'}}>{localStorage.terminalNum}</span>
                </section>
            </div>
            <div>
            {
                localStorage.website !== "" ?
                    <div className={little ? 'installment-info reception-info  noHeight  ' : 'installment-info reception-info'}>
                    <section>
                        <span className='info-titles' > :آدرس وبسایت</span>
                    </section>
                    <section style={{display: 'flex' , flexDirection: 'row-reverse' , marginRight: 13}}>
                        <span className='info-details' style={{fontSize: '14px'}}>{localStorage.website}</span>
                    </section>
                </div> : <span></span>
            }
            {
                localStorage.address !== "" ?
                    <div className={little ? 'installment-info reception-info  noHeight' : 'installment-info' +
                        ' reception-info'} style={{alignItems: 'baseline'}}>
                    <section>
                        <span className='info-titles' > :آدرس</span>
                    </section>
                    <section style={{display: 'flex' , flexDirection: 'row-reverse' , marginRight: 13}}>
                        <span className='info-details' style={{fontSize: '14px' , textAlign: 'right'}}>{localStorage.address}</span>
                    </section>
                </div> : <span></span>
            }
            </div>
        </div>
    )
};
const mstp = state => ({
   amount: state.amount,
   supplierName: state.supplierName,
    website: state.website,
    terminal: state.terminalNum,
    branchName: state.branchName,
    branchCode: state.branchCode
});
export default connect (mstp) (ReceptionInfo);